import { CartAddEvent, CartErrorEvent } from '@theme/events';

if (!window.__tavoloProductAddToCartInit) {
  window.__tavoloProductAddToCartInit = true;

  const getCartSectionIds = () => {
    const ids = new Set();
    document.querySelectorAll('cart-items-component').forEach((el) => {
      if (el instanceof HTMLElement && el.dataset.sectionId) {
        ids.add(el.dataset.sectionId);
      }
    });
    return Array.from(ids);
  };

  const setLabelState = (button, state) => {
    const states = ['default', 'loading', 'success', 'error'];
    states.forEach((s) => {
      const el = button.querySelector(`[data-label-${s}]`);
      if (!el) return;
      if (s === state) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    });
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-tavolo-add]');
    if (!button) return;

    event.preventDefault();
    if (button.hasAttribute('disabled')) return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    button.setAttribute('disabled', 'true');
    button.classList.add('is-loading');
    setLabelState(button, 'loading');

    try {
      const sectionIds = getCartSectionIds();
      const body = {
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
      };
      if (sectionIds.length) body.sections = sectionIds.join(',');

      const response = await fetch(`${Theme.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (!response.ok || data.status) {
        const message = data.description || data.message || 'Errore. Riprova.';
        document.dispatchEvent(new CartErrorEvent('tavolo-product-add', message));
        setLabelState(button, 'error');
        setTimeout(() => {
          setLabelState(button, 'default');
        }, 2500);
        return;
      }

      document.dispatchEvent(
        new CartAddEvent({}, 'tavolo-product-add', {
          source: 'tavolo-product-add',
          itemCount: 1,
          sections: data.sections,
        })
      );

      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && !drawer.hasAttribute('auto-open') && typeof drawer.open === 'function') {
        drawer.open();
      }

      setLabelState(button, 'success');
      setTimeout(() => {
        setLabelState(button, 'default');
      }, 1500);
    } catch (error) {
      console.error(error);
      setLabelState(button, 'error');
      setTimeout(() => {
        setLabelState(button, 'default');
      }, 2500);
    } finally {
      button.classList.remove('is-loading');
      button.removeAttribute('disabled');
    }
  });
}
